import React, { useState, useEffect } from 'react';
import { Title } from 'react-admin';

import { getYearMonthDate } from '../calendar';
import WeeklySchedules from "./WeeklySchedules";
import MainBoard from './MainBoard'

const Dashboard = ({}) => {

  // 'YYYYMMDD'
  // NOTE: 추후 날짜 이동 기능이 필요하면 state 처리 
  const today = getYearMonthDate(new Date());

  // data 
  // ... 

  // additional states 
  const [ loading, setLoading ] = useState(false);

  return (
    <div>
      <Title>관리자 메인</Title>
      <div>
         <MainBoard />
      </div>
      <div>
        <WeeklySchedules
          today={today}
        />
      </div>
    </div>
  )
}

export default Dashboard;